<template>
  <div>
    <section class="pt-4 mb-4">
      <div class="container text-center">
        <div class="row">
          <div class="col-lg-6 text-center text-lg-left">
            <h1 class="fw-600 h4">{{ $t("博客") }}</h1>
          </div>
          <div class="col-lg-6">
            <ul
              class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
            >
              <li class="breadcrumb-item opacity-50">
                <router-link class="text-reset" to="/"
                  >{{ $t("首页") }}
                </router-link>
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset" href="javascript:void(0);">{{
                  $t("博客")
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="pb-4">
      <div class="container">
        <div class="card-columns">
          <div
            v-for="poster in blogPosters"
            :key="poster.id"
            class="card mb-3 overflow-hidden shadow-sm"
          >
            <div class="text-reset d-block" @click="jump(blogUrl(poster))">
              <img
                :src="getFileViewUrl(poster.pic)"
                class="img-fluid lazyloaded"
              />
            </div>
            <div class="p-4">
              <h2 class="fs-18 fw-600 mb-1">
                <a class="text-reset" @click="jump(blogUrl(poster))">
                  {{ poster.title }}
                </a>
              </h2>
              <p class="opacity-70 mb-4">
                {{ poster.subtitle }}
              </p>
              <div class="btn btn-soft-primary" @click="jump(blogUrl(poster))">
                {{ $t("查看更多") }}
              </div>
            </div>
          </div>
        </div>
        <div class="aiz-pagination aiz-pagination-center mt-4"></div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      blogPosters: []
    };
  },
  created() {
    this.getBlogPosters();
  },
  methods: {
    async getBlogPosters() {
      // 博客
      this.blogPosters = await this.getPosters({ cid: "2" });
    },
    blogUrl(poster) {
      return poster.url || `/single-blog?code=${poster.code}`;
    }
  }
};
</script>
